<template>
    <button class="hamburger-btn"
            :class="rootClasses"
            :aria-label="title"
            aria-controls="navigation"
            :aria-expanded="menuSidebar ? 'true' : 'false'"
            @click="onClick(!menuSidebar)">
        <span class="hamburger-btn--title">
            {{ title }}
        </span>
        <span class="hamburger-btn--hamburger hamburger" :class="hamburgerClasses">
            <span class="hamburger-box">
                <span class="hamburger-inner"/>
            </span>
        </span>
    </button>
</template>

<script>
    import { bemMixin } from '@dreipol/vue-ui/src/mixins';
    import { mapFilters } from 'util/vue/map-filters';
    import { mapActions, mapState } from 'vuex';

    export default {
        mixins: [
            bemMixin('hamburger-btn'),
        ],
        computed: {
            ...mapState('project-status', ['menuSidebar']),
            rootClasses() {
                return [
                    this.bemAdd(this.isActiveClass),
                    ...this.bemFacets,
                ];
            },
            hamburgerClasses() {
                return ['hamburger--squeeze', this.isActiveClass];
            },
            isActiveClass() {
                return this.menuSidebar ? 'is-active' : '';
            },
            title() {
                return this.translate(`HAMBURGER_BTN.LABEL_${ this.menuSidebar ? 'OPENED' : 'CLOSED' }`);
            },
        },
        methods: {
            ...mapFilters(['translate']),
            ...mapActions('project-status', ['toggleMenuSidebar']),
            onClick() {
                this.toggleMenuSidebar({ open: !this.menuSidebar });
            },
        },
    };
</script>
